import { Box, Button } from '@chakra-ui/react'

import { Icon } from '../../../../components/Icon'

/** The panel's receipt may be a PDF (ABRA-425); the terminal's is always a photo. */
export const isPdfProof = (url: string) => /\.pdf($|\?)/i.test(url)

export interface IPaymentProofProps {
  url: string
  /** Lower inside the tab detail, where the image shares the space. */
  maxImageHeight?: number
}

/**
 * A manual payment's receipt: the image plus a button to open it, or only the button for a PDF,
 * which an `<img>` cannot show.
 */
export default function PaymentProof({ url, maxImageHeight = 600 }: IPaymentProofProps) {
  const pdf = isPdfProof(url)

  return (
    <>
      {!pdf && (
        <Box borderRadius="lg" border="1px" borderColor="gray.100" overflow="hidden" bg="gray.50">
          <img
            src={url}
            alt="Comprovante de pagamento"
            style={{ width: '100%', maxHeight: maxImageHeight, objectFit: 'contain', display: 'block' }}
          />
        </Box>
      )}
      <Button
        as="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        mt={pdf ? 0 : 3}
        size="sm"
        colorScheme="purple"
        variant="outline"
        w="100%"
        leftIcon={<Icon name={pdf ? 'lni lni-empty-file' : 'lni lni-link'} size="md" />}
      >
        {pdf ? 'Abrir comprovante (PDF)' : 'Abrir em nova aba'}
      </Button>
    </>
  )
}
